export const fakeRules = [
  {
    "id": 34,
    "is_event": true,
    "event_type": "Daily",
    "events": "কুইজ প্রতিদিন",
    "round": 2,
    "status": "active",
    "question_set": "60",
    "passing_score": 30,
    "allocated_time": 180,
    "banner_url": "/banners/daily.png",
    "company_id": 15,
    "prize1": "জিতুন ৪০০০ টাকা পর্যন্ত ক্যাশ ইন প্রাইজ!",
    "prize2": null,
    "prize3": null
  },
  {
    "id": 75,
    "is_event": true,
    "event_type": "Tournament",
    "events": "স্পোর্টস কুইজ",
    "round": 2,
    "status": "active",
    "question_set": "60",
    "passing_score": 30,
    "allocated_time": 180,
    "banner_url": "/banners/sports.png",
    "company_id": 15,
    "prize1": "জিতুন ৩ ০০০ টাকা পর্যন্ত ক্যাশ ইন প্রাইজ!",
    "prize2": null,
    "prize3": null
  },
  {
    "id": 149,
    "is_event": true,
    "event_type": "Tournament",
    "events": "BCS প্রস্তুতি",
    "round": 2,
    "status": "active",
    "question_set": "60",
    "passing_score": 30,
    "allocated_time": 180,
    "banner_url": "/banners/bcs.png",
    "company_id": 15,
    "prize1": "জিতুন ৩০০০ টাকা পর্যন্ত ক্যাশ ইন প্রাইজ!",
    "prize2": null,
    "prize3": null
  },
  {
    "id": 150,
    "is_event": true,
    "event_type": "Tournament",
    "events": "টুর্নামেন্ট কুইজ",
    "round": 2,
    "status": "active",
    "question_set": "60",
    "passing_score": 30,
    "allocated_time": 180,
    "banner_url": "/banners/tournament.png",
    "company_id": 15,
    "prize1":  '১ম পুরস্কার (Quiz King): Samsung  32" স্মার্ট টিভি \n',
    "prize2": "২য় পুরস্কার (Quiz Champion): Samsung Galaxy A16 স্মার্ট ফোন \n",
    "prize3": "৩য় পুরস্কার (Quiz Star):  স্মার্টওয়াচ <br>৪র্থ পুরস্কার (Quiz Expert): ৩,০০০ টাকা ক্যাশ ইন <br>৫ম পুরস্কার ( Quiz Challenger): ২,০০০ টাকা ক্যাশ ইন"
  }
]